import React from 'react';
import SectionOneDetails from './SectionOneDetails/SectionOneDetails';

const SectionOne = () => {
     const chooses = [
          {
               id: 1,
               img: 'https://i.pinimg.com/564x/d4/7e/66/d47e669402b7c7737a1255776628cc79.jpg', post: 'If you want the quality you would expect from the dealership, but with a more personal and friendly atmosphere, you have found it.', title: 'EVERY JOB IS PERSONAL'
          },
          {
               id: 2,
               img: 'https://i.pinimg.com/564x/b9/31/b3/b931b397ac9d4a23d935d9d4944ee8bd.jpg', post: 'We have invested in all the latest specialist tools and diagnostic software that is specifically tailored for the software in your vehicle.', title: 'BEST MATERIALS'
          },
          {
               id: 3,
               img: 'https://i.pinimg.com/564x/5c/68/66/5c686628ca5d2f1396d3874d806a6445.jpg', post: 'Our auto repair shop is capable of servicing a variety of models. We only do the work that is needed to fix your problem.', title: 'PROFESSIONAL STANDARDS'
          }
     ]
     return (
          <div className='text-center my-5 py-2'>
               <h3 className='fw-bolder text-primary'>WHY CHOOSE OUR CARS?</h3>
               <p>We are one of the leading auto repair shops serving customers in Tucson <br></br>
                    All mechanic services are performed by highly qualified mechanics.</p>
               <div className='cars mt-4 container'>
                    {
                         chooses.map(choose => <SectionOneDetails
                              key={choose.id}
                              choose={choose}
                         ></SectionOneDetails>)
                    }

               </div>
               <button className='btn btn-primary p-2 mt-3 fw-bolder'>READ MORE 🡲</button>
          </div>
     );
};

export default SectionOne;